import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

// import { DEAL_FORM } from '../forms/schema';
import c from '../utils/constants';

interface Payload {
  dealId: string[];
}

enum SOURCE {
  companies = 'companyId',
  leads = 'leadId',
}

export default function useUpdateDeal(
  id: string,
  source: 'companies' | 'leads',
) {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (payload: Payload) => {
      const api = new Api(args);

      const data = await api.patch(
        await withAcl({
          account: {
            url: `/api/v1/contacts/${source}/${id}/references/deals`,
            payload,
          },
          admin: {
            // eslint-disable-next-line max-len
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/contacts/${source}/${id}/references/deals`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      setTimeout(() => {
        queryClient.invalidateQueries({
          queryKey: [c.DEALS, { [SOURCE[source]]: id }],
        });
        queryClient.invalidateQueries({ queryKey: [c.LOGS, id] });
      }, 200);

      toastSuccess('Successfully updated deal.');
    },
  });
}
